import { FlexBox } from "components/Common/FlexBox"
import { Link } from "react-router-dom"
import styled from "styled-components"

export const YourGoalWrapper = styled.div`
  position: relative;
  height: calc(
    100% - var(--app-top-navigation-height) - var(--profile-header-height)
  );
  background: linear-gradient(180deg, #00263a 53.39%, #141415 100%);
  color: #fff;
`

export const YourGoalContent = styled.div`
  position: relative;
  padding: 12px var(--app-horizontal-padding);
  display: flex;
  flex-direction: column;
  gap: var(--spacing_l, 16px);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  padding-bottom: var(--cta-height);
`

export const FullscreenCloseButton = styled.div`
  position: absolute;
  top: 16px;
  left: 19px;
  z-index: 20;
  cursor: pointer;
`

export const StyledGoalOverview = styled.div`
  display: flex;
  padding: var(--spacing_l, 16px);
  flex-direction: column;
  align-items: center;
  gap: 8px;
`



